import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "tw-w-full" }
const _hoisted_2 = { class: "tw-overflow-x-auto" }
const _hoisted_3 = { class: "tw-min-w-full tw-text-left tw-text-sm tw-text-slate-700" }
const _hoisted_4 = { class: "tw-divide-y tw-divide-slate-200/70" }
const _hoisted_5 = { class: "odd:tw-bg-white/30" }
const _hoisted_6 = { class: "tw-px-4 tw-py-3" }
const _hoisted_7 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2 tw-py-1"
}
const _hoisted_8 = { class: "tw-min-w-[240px]" }
const _hoisted_9 = {
  key: 1,
  class: "tw-flex tw-items-center tw-justify-between tw-gap-2"
}
const _hoisted_10 = { class: "tw-min-w-0" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "tw-text-slate-400"
}
const _hoisted_13 = { class: "tw-px-4 tw-py-3" }
const _hoisted_14 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2 tw-py-1"
}
const _hoisted_15 = { class: "tw-min-w-[240px]" }
const _hoisted_16 = {
  key: 1,
  class: "tw-flex tw-items-center tw-justify-between tw-gap-2"
}
const _hoisted_17 = { class: "tw-min-w-0" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "tw-text-slate-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDateTimePicker = _resolveComponent("BaseDateTimePicker")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "tw-flex tw-items-center tw-justify-between tw-px-1 tw-py-2" }, [
      _createElementVNode("div", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "Container appointments"),
      _createElementVNode("div")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("thead", { class: "tw-bg-slate-50/70 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Terminal appointment"),
            _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Delivery appointment")
          ])
        ], -1)),
        _createElementVNode("tbody", _hoisted_4, [
          _createElementVNode("tr", _hoisted_5, [
            _createElementVNode("td", _hoisted_6, [
              (_ctx.editingField === 'terminal')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_BaseDateTimePicker, {
                        "value-type": "YYYY-MM-DD HH:mm",
                        "date-format": "MM/DD/YYYY",
                        "date-time-format": "MM/DD/YYYY HH:mm",
                        "allow-time-toggling": true,
                        "show-days-shortcuts": true,
                        "controls-placement": "popup",
                        "minute-step": 15,
                        textLabel: "",
                        "time-panel-placement": "beside-calendar",
                        modelValue: _ctx.editingContainer.terminalAppointmentDate,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editingContainer.terminalAppointmentDate) = $event)),
                        "has-time": _ctx.editingContainer.terminalAppointmentHasTime,
                        "onUpdate:hasTime": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editingContainer.terminalAppointmentHasTime) = $event))
                      }, null, 8, ["modelValue", "has-time"])
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white",
                      title: "Cancel",
                      "aria-label": "Cancel",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelInlineEdit && _ctx.cancelInlineEdit(...args)))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "xmark",
                        class: "tw-h-4 tw-w-4"
                      })
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-transparent tw-bg-slate-900 tw-text-white hover:tw-bg-slate-800",
                      title: "Save",
                      "aria-label": "Save",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveInlineEdit('terminal')))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "check",
                        class: "tw-h-4 tw-w-4"
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (_ctx.container.terminalAppointmentDate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.formatAppointmentDatetime(_ctx.container.terminalAppointmentDate, _ctx.container.terminalAppointmentHasTime, true)), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_12, "—"))
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "tw-inline-flex tw-h-8 tw-w-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white",
                      title: "Edit terminal appointment",
                      "aria-label": "Edit terminal appointment",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.startInlineEdit('terminal')))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "pen-to-square",
                        class: "tw-h-4 tw-w-4"
                      })
                    ])
                  ]))
            ]),
            _createElementVNode("td", _hoisted_13, [
              (_ctx.editingField === 'delivery')
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_BaseDateTimePicker, {
                        "value-type": "YYYY-MM-DD HH:mm",
                        "date-format": "MM/DD/YYYY",
                        "date-time-format": "MM/DD/YYYY HH:mm",
                        "allow-time-toggling": true,
                        "show-days-shortcuts": true,
                        "controls-placement": "popup",
                        "minute-step": 15,
                        textLabel: "",
                        "time-panel-placement": "beside-calendar",
                        modelValue: _ctx.editingContainer.deliveryAppointmentDate,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editingContainer.deliveryAppointmentDate) = $event)),
                        "has-time": _ctx.editingContainer.deliveryAppointmentHasTime,
                        "onUpdate:hasTime": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editingContainer.deliveryAppointmentHasTime) = $event))
                      }, null, 8, ["modelValue", "has-time"])
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white",
                      title: "Cancel",
                      "aria-label": "Cancel",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.cancelInlineEdit && _ctx.cancelInlineEdit(...args)))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "xmark",
                        class: "tw-h-4 tw-w-4"
                      })
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-transparent tw-bg-slate-900 tw-text-white hover:tw-bg-slate-800",
                      title: "Save",
                      "aria-label": "Save",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveInlineEdit('delivery')))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "check",
                        class: "tw-h-4 tw-w-4"
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      (_ctx.container.deliveryAppointmentDate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.formatAppointmentDatetime(_ctx.container.deliveryAppointmentDate, _ctx.container.deliveryAppointmentHasTime, true)), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_19, "—"))
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "tw-inline-flex tw-h-8 tw-w-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white",
                      title: "Edit delivery appointment",
                      "aria-label": "Edit delivery appointment",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.startInlineEdit('delivery')))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "pen-to-square",
                        class: "tw-h-4 tw-w-4"
                      })
                    ])
                  ]))
            ])
          ])
        ])
      ])
    ])
  ]))
}